import type Store from "@ember-data/store";
import type BioExamFrequencyChangedJournalEvent from "parog-web/models/bio-exam-frequency-changed-journal-event";

export default async function loadBioExamFrequencyLoincs(
  store: Store,
  journalEvents: BioExamFrequencyChangedJournalEvent[]
): Promise<void> {
  const allLoincs = [...new Set(journalEvents.flatMap(je => je.loincs))].sort();
  const missingLoincs = allLoincs.filter(code => {
    const loinc = store.peekRecord("loinc", code);
    return !loinc || !loinc.bioExamOrder;
  });

  if (missingLoincs.length === 0) return;

  await store.query("loinc", {
    filter: { loinc: missingLoincs },
    include: "bio-exam-order"
  });
}
